<template>
  <SelectSingleInput
    v-model="model"
    :items="items"
    item-text="partText"
    item-value="partCd"
    :label="label"
    :disabled="disabled"
    :loading="loading"
    :required="required"
    :isSelectedAuto="false"
    @change="onChange"
    @searchInput="onSearchInput"
  />
</template>

<script>
import SelectSingleInput from '@/components/atoms/base/select/SelectSingleInput'
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'

export default {
  name: 'PartCodeInput',

  mixins: { APIUtils, Message },
  components: { SelectSingleInput },

  props: {
    value: {
      type: String,
      default: '',
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
    label: {
      type: String,
      required: false,
      default: function () {
        return this.$t('ELE0059')
      },
    },
    validOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      items: [],
      loading: false,
    }
  },

  watch: {
    value(value) {
      if (this.canSearchPartList(value)) {
        this.setParts(value)
      }
    },
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value ? value : '')
      },
    },
  },

  methods: {
    canSearchPartList(value) {
      // 3文字以上の入力があった場合のみ、プルダウン候補取得 (APIで大量データを検索しないように)
      let result = false
      if (value && value.length >= 3) {
        result = true
      }
      return result
    },
    onChange() {
      this.$emit('change')
    },
    onSearchInput(e) {
      if (e !== null) {
        this.setParts(e)
      }
    },

    async setParts(inputText) {
      if (this.canSearchPartList(inputText)) {
        try {
          this.loading = true

          let item = this.items.find((item) => item.partCd == this.model)
          if (item) {
            // コードが既にプルダウン選択肢にある場合は何もしない
          } else {
            let params = { partCd: inputText, partName: inputText }
            if (this.validOnly) {
              params.validOnly = true
            }
            const elements = await API.get('/master/partCds', params)
            this.items = []
            elements.forEach((element) => {
              element['partText'] = `${element['partCd']} : ${element['partName']}`
              this.items.push(element)
            })
          }
        } catch (error) {
          this.items = []
          this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0059') })))
        } finally {
          this.loading = false
        }
      } else {
        this.model = ''
        this.items = []
      }
    },
  },

  async mounted() {
    await this.setParts(this.value)
  },
}
</script>
